import { BasePool } from "../pool";
import type { ServiceContainer, ServiceProvider } from "../service-container";
import { BaseReversePixelMapperResolver } from "./BaseReversePixelMapperResolver";
import { Distortion } from "./Distortion";
import {
  AffineFactory,
  AffineProjectionFactory,
  ArcFactory,
  PerspectiveFactory,
  PerspectiveProjectionFactory,
  PolynomialFactory,
} from "./distortions";
import type { ReversePixelMapperFactoriesPool } from "./ReversePixelMapperFactoriesPool";

/**
 * Pixel mapping service provider.
 * @internal
 */
export const pixelMappingProvider: ServiceProvider = {
  /**
   * Registers entities, related to pixel mapping, in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: ReversePixelMapperFactoriesPool = new BasePool();
    pool.add(Distortion.ARC, new ArcFactory());
    pool.add(Distortion.AFFINE, new AffineFactory());
    pool.add(Distortion.AFFINE_PROJECTION, new AffineProjectionFactory());
    pool.add(Distortion.PERSPECTIVE, new PerspectiveFactory());
    pool.add(
      Distortion.PERSPECTIVE_PROJECTION,
      new PerspectiveProjectionFactory()
    );
    pool.add(Distortion.POLYNOMIAL, new PolynomialFactory());
    container.register("ReversePixelMapperFactoriesPool", pool);

    container.register("ReversePixelMapperResolver", (c) => {
      return new BaseReversePixelMapperResolver(
        c.resolve("ReversePixelMapperFactoriesPool")
      );
    });
  },
};
